import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '../ui/button'

import { navigatetoHome } from '@/utils/footer-navigations'

function PlanUpgradeDialog({
  showPlanUpgrade,
  setShowPlanUpgrade,
  name = 'This feature',
  desc = '',
}) {
  return (
    <Dialog open={showPlanUpgrade} onOpenChange={setShowPlanUpgrade}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Premium Feature</DialogTitle>
          <DialogDescription>
            {name} is available in Premium or Enterprise plans. Upgrade to unlock this feature and
            many more.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg">
          <span className="text-2xl">🔒</span>
          <div>{desc && <p className="text-sm text-gray-600 mt-1">{desc}</p>}</div>
        </div>
        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            className="rounded-full text-theme-color-700 border-theme-color-700 hover:bg-theme-color-700 hover:text-white"
            onClick={() => setShowPlanUpgrade(false)}
          >
            Maybe Later
          </Button>
          <button
            className="px-4 py-1.5 bg-theme-color-700 text-white text-sm font-medium rounded-full 
                         hover:bg-white hover:text-theme-color-800 hover:border hover:border-theme-color-700 transition-colors cursor-pointer"
            onClick={(e) => {
              e.stopPropagation()
              navigatetoHome('/#prices')
              setShowPlanUpgrade(false)
            }}
          >
            Upgrade Now
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default PlanUpgradeDialog
